import { useEffect, useState } from 'react';

// 화면 크기 구간 (style.css 의 @media 조건과 반드시 같게 유지)
//  - COMPACT: 휴대폰 세로, 또는 높이가 낮은 휴대폰 가로 → 채널·접속자 목록을 서랍으로
//  - NARROW : 태블릿 세로 등 → 접속자 목록만 오른쪽에서 겹쳐 열기
export const COMPACT_QUERY = '(max-width: 767px), (max-height: 500px) and (pointer: coarse)';
export const NARROW_QUERY = '(max-width: 1099px), (max-height: 500px) and (pointer: coarse)';

const matches = (query) => typeof window !== 'undefined' && !!window.matchMedia?.(query).matches;

export function useMediaQuery(query) {
    const [value, setValue] = useState(() => matches(query));
    useEffect(() => {
        const mql = window.matchMedia(query);
        const onChange = () => setValue(mql.matches);
        onChange();
        mql.addEventListener('change', onChange);
        return () => mql.removeEventListener('change', onChange);
    }, [query]);
    return value;
}

export const isCompactViewport = () => matches(COMPACT_QUERY);
export const isNarrowViewport = () => matches(NARROW_QUERY);
